export default __webpack_public_path__ + "static/img2-66c5de1d1e2beda69974b026adf683e4.png";